import styled from 'styled-components';

const StyledHeroVirtualShowroom = styled.div`
  position: relative;
  .hero-virtual--wrap{
    position: relative;
    height: 100vh; /* Fallback for browsers that do not support Custom Properties */
    height: calc(var(--vh, 1vh) * 100);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    video{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      overflow: hidden;
      display: block;
      min-width: 100%; 
      min-height: 100%; 
      width: 100%; 
      height: auto; 
      background-size: cover;
      object-fit: cover;
      z-index: 1;
    }
    h4 {
      position: relative;
      z-index: 3;
      color: #fff;
      left: 8%;
      width: 50%;
    }
  }
`;

export {
  StyledHeroVirtualShowroom,
};
